import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddCandidateSchema, ICandidateState } from './types';

const initialState: ICandidateState = {
  addCandidate: {},
  candidates: {},
  updateCandidate: {},
  updateCandidateStatus: {},
  candidateDetailsById: {},
};

const slice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {
    addCandidate(state, action: PayloadAction<IAddCandidateSchema>) {
      state.addCandidate.status = RequestStatus.RUNNING;
    },
    addCandidateSuccess(state, action) {
      state.addCandidate.status = RequestStatus.SUCCESS;
      state.addCandidate.data = action.payload;
    },
    addCandidateFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCandidate.status = RequestStatus.ERROR;
      state.addCandidate.error = action.payload;
    },
    //
    getCandidates(state, action: PayloadAction<string | undefined>) {
      state.candidates.status = RequestStatus.RUNNING;
    },
    getCandidatesSuccess(state, action: PayloadAction<ICandidateState['candidates']['data']>) {
      state.candidates.status = RequestStatus.SUCCESS;
      state.candidates.data = action.payload;
    },
    getCandidatesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.candidates.status = RequestStatus.ERROR;
      state.candidates.error = action.payload;
    },
    //
    //
    getCandidatesDetailsByID(state) {
      state.candidateDetailsById.status = RequestStatus.RUNNING;
    },
    getCandidatesDetailsByIDSuccess(
      state,
      action: PayloadAction<ICandidateState['candidateDetailsById']['data']>
    ) {
      state.candidateDetailsById.status = RequestStatus.SUCCESS;
      state.candidateDetailsById.data = action.payload;
    },
    getCandidatesDetailsByIDFailed(state, action: PayloadAction<IRequestFailed>) {
      state.candidateDetailsById.status = RequestStatus.ERROR;
      state.candidateDetailsById.error = action.payload;
    },
    updateCandidate(state, action: PayloadAction<any>) {
      state.updateCandidate.status = RequestStatus.RUNNING;
    },
    updateCandidateSuccess(state, action: PayloadAction<IAddCandidateSchema>) {
      state.updateCandidate.status = RequestStatus.SUCCESS;
      state.updateCandidate.data = action.payload;
    },
    updateCandidateFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateCandidate.status = RequestStatus.ERROR;
      state.updateCandidate.error = action.payload;
    },
    //
    updateCandidateStatus(state, action: PayloadAction<IAddCandidateSchema>) {
      state.updateCandidateStatus.status = RequestStatus.RUNNING;
    },
    updateCandidateStatusSuccess(state, action: PayloadAction<IAddCandidateSchema>) {
      state.updateCandidateStatus.status = RequestStatus.SUCCESS;
      state.updateCandidateStatus.data = action.payload;
    },
    updateCandidateStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateCandidateStatus.status = RequestStatus.ERROR;
      state.updateCandidateStatus.error = action.payload;
    },
    //
  },
});
export default slice.reducer;

export const {
  addCandidate,
  addCandidateSuccess,
  addCandidateFailed,
  getCandidates,
  getCandidatesFailed,
  getCandidatesSuccess,
  updateCandidate,
  updateCandidateFailed,
  updateCandidateSuccess,
  updateCandidateStatus,
  updateCandidateStatusSuccess,
  updateCandidateStatusFailed,
  getCandidatesDetailsByID,
  getCandidatesDetailsByIDSuccess,
  getCandidatesDetailsByIDFailed,
} = slice.actions;
